import { qportalApi } from './qportal-api';
const path = (id) => encodeURIComponent(id);
const McpApi = {
    consent: async (requestId) => (await qportalApi.get(`mcp/consent/${path(requestId)}`)).data,
    approve: async (requestId, scopes, stepUpGrant) => (await qportalApi.post(`mcp/consent/${path(requestId)}/approve`, { scopes, stepUpGrant })).data,
    deny: async (requestId) => (await qportalApi.post(`mcp/consent/${path(requestId)}/deny`, {})).data,
    connections: async () => (await qportalApi.get('mcp/connections')).data,
    revokeConnection: async (id) => {
        await qportalApi.delete(`mcp/connections/${path(id)}`);
    },
    // SuperAdmin only. Revoking one connection needs the session only; revoke-all needs a fresh mcp.revoke-all step-up.
    allConnections: async () => (await qportalApi.get('mcp/admin/connections')).data,
    revokeAnyConnection: async (id) => {
        await qportalApi.post(`mcp/admin/connections/${path(id)}/revoke`, {});
    },
    revokeAll: async (stepUpGrant) => (await qportalApi.post('mcp/admin/revoke-all', { stepUpGrant })).data,
    // Strong admin session of the admin who prepared it. Confirm sends the mcp.decision step-up grant, or null when the
    // view said no step-up is needed. A repeated confirm returns the recorded outcome and runs nothing again.
    decision: async (id) => (await qportalApi.get(`mcp/decisions/${path(id)}`)).data,
    confirmDecision: async (id, stepUpGrant) => (await qportalApi.post(`mcp/decisions/${path(id)}/confirm`, { stepUpGrant })).data,
    cancelDecision: async (id) => (await qportalApi.post(`mcp/decisions/${path(id)}/cancel`, {})).data
};
export default McpApi;
